var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 222.492,
    height: 129,
    viewBox: "0 0 222.492 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 2.5,
    y: 2.5,
    width: 217.492,
    height: 124,
    rx: 4,
    stroke: "#D6AF66",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M122.789 51.8355C124.991 53.482 126.778 55.617 128.009 58.0714C129.239 60.5258 129.88 63.2322 129.88 65.9763C129.88 68.7204 129.239 71.4269 128.009 73.8813C126.778 76.3357 124.991 78.4707 122.789 80.1171M132.362 41.2299C136.063 44.2124 139.048 47.9826 141.099 52.2644C143.15 56.5462 144.214 61.2312 144.214 65.9763C144.214 70.7214 143.15 75.4064 141.099 79.6882C139.048 83.9701 136.063 87.7403 132.362 90.7227M90.8819 76.5819H83.7913C82.851 76.5819 81.9492 76.2095 81.2844 75.5465C80.6195 74.8835 80.246 73.9843 80.246 73.0467V58.9059C80.246 57.9683 80.6195 57.0691 81.2844 56.4062C81.9492 55.7432 82.851 55.3707 83.7913 55.3707H90.8819L103.29 39.4623C103.6 38.8621 104.115 38.3923 104.742 38.1377C105.369 37.883 106.067 37.8604 106.709 38.0738C107.351 38.2873 107.896 38.7228 108.244 39.3016C108.592 39.8804 108.722 40.5644 108.608 41.2299V90.7227C108.722 91.3883 108.592 92.0722 108.244 92.651C107.896 93.2299 107.351 93.6653 106.709 93.8788C106.067 94.0923 105.369 94.0696 104.742 93.815C104.115 93.5604 103.6 93.0905 103.29 92.4903L90.8819 76.5819Z",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioTablet);
export default __webpack_public_path__ + "static/media/audio-tablet.b90e1dcf032b1c91fbb8c959e77812c9.svg";
export { ForwardRef as ReactComponent };